import * as Objdict from "objdict"
import shortid from "shortid"

import Stage from "@frog/source/models/Stage.js"
import Step from "@frog/source/models/Step.js"
import Random from "@frog/source/utility/Random.js"
import Geometry from "@frog/source/utility/Geometry.js"

import Ink from "@frog/source/utility/Ink.js"
import InkDialogue from "@frog/source/utility/InkDialogue.js"

import ranges from "@frog/source/data/skills/parts/ranges.js"

const skills = {}
export default skills

skills["water"] = {
    "type": "invoke",
    "class": "support",
    "canCounterattack": false,
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.type != "plant") return false
        return true
    },

    "range": ranges["short"],

    "name": "Farm",

    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        let wasHarvested = false

        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const deltastages = []
        const HIT_MARK = 0

        Step.add(step, {"mark": HIT_MARK, "flourish": {"name": "NudgedMovement", "unit": {"key": performer.key}, "direction": direction, "position": performer.position}})

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return step
        target.properties = target.properties || {}

        let healing = 1
        if(target.health + healing > target.maxhealth) {
            healing = target.maxhealth - target.health
        }
        Step.add(step, {
            "mark": HIT_MARK,
            "unit": {
                "key": target.key,
                "health": target.health + healing
            }
        })

        if(target.level <= target.properties.maxlevel
        && (target.properties.isFinicky != true || target.state != "watered")) {
            Step.add(step, {
                "mark": HIT_MARK,
                "unit": {
                    "key": target.key,
                    "level": target.level + 1,
                    "state": "watered",
                },
            })
            Step.add(step, {
                "mark": HIT_MARK,
                "func": function() {
                    if(window.tutorial2 == 0
                    || window.tutorial2 == 1) {
                        window.tutorial2 += 1
                    }
                },
            })
        }

        if(target.level >= target.properties.maxlevel) {
            if(target.properties.isBlooming == true) {
                Step.add(step, {
                    "mark": HIT_MARK,
                    "unit": {
                        "key": target.key,
                        "level": target.properties.levelregress,
                    },
                })
                Step.add(step, {
                    "mark": HIT_MARK,
                    "unit": {
                        "key": performer.key,
                        "score": (performer.score || 0) + (target.properties.score || 1),
                    },
                })
                Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Harvest"}})

                wasHarvested = true
            } else if(target.properties.isSpreading == true) {
                const directions = [Geometry.directions.north, Geometry.directions.south, Geometry.directions.east, Geometry.directions.west]
                directions.forEach((direction) => {
                    const previousPosition = target.position
                    const nextPosition = Geometry.add(target.position, direction)
                    const collision = Stage.findCollision({stage, previousPosition, nextPosition})
                    if(collision == undefined) {
                        Step.add(step, {
                            "mark": HIT_MARK,
                            "unit": {
                                "position": Geometry.add(target.position, direction),
                                "class": target.properties.spreadclass,
                            }
                        })
                    }
                })
            } else {
                Step.add(step, {
                    "mark": HIT_MARK,
                    "unit": {
                        "key": target.key,
                        "hasBeenRemoved": true,
                    },
                })
                Step.add(step, {
                    "mark": HIT_MARK,
                    "unit": {
                        "key": performer.key,
                        "score": (performer.score || 0) + (target.properties.score || 1),
                    },
                })
                Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Harvest"}})
                wasHarvested = true
            }
        }

        if(wasHarvested == false) {
            Step.add(step, {"mark": 0, "audio": {"triggerKey": "Unit:Garden"}})
        }

        if(target.properties.isThorny == true
        && this.range.min == 1 && this.range.max == 1) {
            Step.add(step, {
                "mark": HIT_MARK,
                "unit": {
                    "key": performer.key,
                    "health": performer.health - 1,
                },
            })
        }

        Step.add(step, {"mark": HIT_MARK, "flourish": {"name": "NudgedMovement", "unit": {"key": target.key}, "direction": Geometry.flip(direction), "position": target.position}})
        Step.add(step, {"mark": HIT_MARK, "flourish": {"name": "TextFloat", "position": target.position, "text": healing}})

        step.followupSteps = []
        function queueupEvent(event) {
            step.followupSteps.push(Stage.processEventSteps(step.omegastage, event))
        }

        queueupEvent({"func": (stage) => Ink.increment(performer.type + "_garden_count")})
        queueupEvent({"func": (stage) => Ink.increment(performer.classname + "_garden_count")})

        queueupEvent(InkDialogue(target.type + "_was_gardened"))
        queueupEvent(InkDialogue(target.classname + "_was_gardened"))

        queueupEvent(InkDialogue(performer.type + "_has_gardened_" + target.type))
        queueupEvent(InkDialogue(performer.type + "_has_gardened_" + target.classname))
        queueupEvent(InkDialogue(performer.classname + "_has_gardened_" + target.type))
        queueupEvent(InkDialogue(performer.classname + "_has_gardened_" + target.classname))

        if(wasHarvested == true) {
            queueupEvent({"func": (stage) => Ink.increment(performer.type + "_harvest_count")})
            queueupEvent({"func": (stage) => Ink.increment(performer.classname + "_harvest_count")})

            queueupEvent(InkDialogue(target.type + "_was_harvested"))
            queueupEvent(InkDialogue(target.classname + "_was_harvested"))

            queueupEvent(InkDialogue(performer.type + "_has_harvested_" + target.type))
            queueupEvent(InkDialogue(performer.type + "_has_harvested_" + target.classname))
            queueupEvent(InkDialogue(performer.classname + "_has_harvested_" + target.type))
            queueupEvent(InkDialogue(performer.classname + "_has_harvested_" + target.classname))
        }

        return step
    }
}

skills["curse"] = {
    "type": "at-end-of-turn",
    "canCounterattack": false,
    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        Step.add(step, {
            "mark": 0,
            "unit": {
                "key": performerKey,
                "level": 1,
            },
        })

        return step
    },
}

skills["wither"] = {
    "type": "at-end-of-player-turn",
    "canCounterattack": false,
    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]

        if(performer.state == "withered") {
            Step.add(step, {
                "mark": 0,
                "unit": {
                    "key": performerKey,
                    "hasBeenRemoved": true,
                },
            })
        } else {
            if(performer.level > 1) {
                Step.add(step, {
                    "mark": 0,
                    "unit": {
                        "key": performer.key,
                        "state": "withered",
                    },
                })
            }
        }

        return step
    },
}
